import ConfigDB from "../config/Theme";

export const Href: string = "#JavaScript";
export const ThemePrimary: string = "var(--theme-default)";
export const Primary = ConfigDB.color.primaryColor || "var(--theme-default)";
export const Secondary = ConfigDB.color.secondaryColor || "var(--theme-secondary)";

//auth
export const DoNotHaveAccount: string = "Don't have account?";
export const CreateAccount: string = "Create Account";
export const EmailAddress: string = "Email address";
export const ForgotPassword: string = "Forgot password?";
export const Password: string = "Password";
export const RememberPassword: string = "Remember password";
export const SignIn: string = "Sign in";
export const SignInAccount: string = "Sign in to account";
export const SignInWith: string = "Or Sign in with";
export const TwitterLink: string = "Twitter";
export const FacebookLink: string = "Facebook";
export const LinkedIn: string = "LinkedIn";
export const AgreeWith: string = "Agree with";
export const CreateYourAccount: string = "Create your account";
export const PrivacyPolicy: string = "Privacy Policy";
export const YourName: string = "Your Name";
export const EnterYourPassword: string = "Enter your Password";
export const Unlock: string = "UNLOCK";
export const ResetYourPassword: string = "Reset Your Password";
export const EnterYourMobileNumber: string = "Enter Your Mobile Number";
export const Resend: string = " Resend ";
export const EnterOtp: string = "Enter OTP";
export const CreateYourPassword: string = "Create Your Password";
export const NewPassword: string = "New Password";
export const RetypePassword: string = "Retype Password";
export const MAINTENANCE: string = "MAINTENANCE";
export const SignUpAccount: string = "Sign up to account";
export const EnterDetails: string = "Enter your email & password to login";
export const Finish: string = "Finish";
export const Phone: string = "Phone";
export const Birthday: string = "Birthday:";
export const Done: string = "Done";
export const Send: string = "Send";
export const ConfirmPassword: string = "Confirm Password";
export const FirstName: string = "First name";
export const LastName: string = "Last name";
export const City: string = "City";
export const State: string = "State";
export const Country: string = "Country";
export const Address: string = "Address";
export const PostalCode: string = "Postal Code";
export const ZipCode: string = "Zip Code";

//layout
export const Pinned: string = "Pinned";
export const CartTitle: string = "Cart";
export const Back: string = "Back";
export const Checkout: string = "Checkout";
export const EmptyCart: string = "Oops! Your cart empty!!!";
export const ViewCart: string = "View Cart";
export const OrderTotal: string = "Order Total :";
export const Bookmarks: string = "Bookmark";
export const AddNewBookmark: string = "Add New Bookmark";
export const CheckAll: string = "Check all";
export const NotificationTitle: string = "Notifications";
export const MessageTitle: string = "Message";
export const Cancel: string = "Cancel";
export const ConfigurationTitle: string = "Configuration";
export const CopyTextButton: string = "Copy Text";
export const LayoutTypeTitle: string = "Layout Type";
export const SidebarIconTitle: string = "Sidebar Icon";
export const ApplyButton: string = "Apply";
export const UnlimitedColorTitle: string = "Unlimited Color";
export const LightLayoutTitle: string = "Light layout";
export const DarkLayoutTitle: string = "Dark layout";
export const MixLayoutTitle: string = "Mix Layout";
export const SidebarTypeTitle: string = "Sidebar Type";
export const LogOut: string = "Log out";

//Pages
export const Pages: string = "Pages";
export const SamplePageTitle: string = "Sample Page";
export const SampleCardTitle: string = "Sample Card";
//configuartion
export const Configuration: string = "Configuration";
//distributary zone
export const distributaryZoneTitle: string = "Distributary/Zone";
export const distributaryZone: string = "Distributary/Zone";
export const addDistributaryTitle: string = "Add Distributary/Zone";
export const updateDistributaryTitle: string = "Update Distributary/Zone";
//schemeVillage
export const schemeTitle: string = "Scheme/village";
export const addSchemeTitle: string = "Add Scheme/village";
export const updateSchemeTitle: string = "Update Scheme/village";
// Users
export const usersTitle: string = "Users";
export const editUserTitle: string = "Edit User";
export const addUserTitle: string = "Add User";
export const updateUserTitle: string = "Update User";
export const updatePasswordTitle: string = "Update Password";
export const updateUserProfile: string = "User Details"

// Chack
export const chackTitle: string = "Chak";
export const addChack : string = "Add Chak"
export const updateChacks: string = "Update Chak"

//chack Instrument
export const chackInstrumentTitle: string = "Chak Instrument";
export const addChackInstrument : string = "Add Chak Instrumenmt";
export const updateChackInstrumentS: string = "Update Chak Instrument";


//email
export const emailTitle: string = "Email";
export const addEmail: string = "Add Email";
export const updateEmails:string =" Update Email"
//chack valve detail
export const chackValveDetailTitle: string = "Chak Valve Detail";
export const adChackValve:string = "Add Chak Valve"
export const updateChackValve : string = "Update Chak Valve "
//khasara
export const khasaraTitle: string = "Khasara";
export const addKhasara : string = "Add Khasara"
export const updateKhasaras:string = "Update Khasara"
//Farmer
export const FarmerTitle: string = "Farmer"
//chack Valve

//Kml

export const kmlTitle : string = "Kml"
export const addKml : string = "Add Kml"
export const updateKml:string = "Update Kml"

//settings

export const settings : string = "Settings"
